import { IAuditNode, IPatient } from '@alberta/konexi-shared';
import { Component, Input, OnInit } from '@angular/core';
import { CrossTherapyArticleLineViewModel } from 'src/app/business/cross-therapy/cross-therapy-article-line-view-model';
import { InfoBoxType } from 'src/app/shared/components/common/info-box/info-box.component';

import { UserDto } from './../../../../../../models/user-management/user-dto.model';

@Component({
  selector: 'swodoc-node-crossTherapy-article-list-item',
  templateUrl: './swodoc-node-crossTherapy-article-list-item.html',
  styleUrls: ['./swodoc-node-crossTherapy-article-list-item.scss'],
})
export class SwodocNodeCrossTherapyArticleListItem implements OnInit {
  @Input() articleLine: CrossTherapyArticleLineViewModel;
  @Input() node: IAuditNode;
  @Input() patient: IPatient;
  @Input() user: UserDto;
  @Input() showScanButtons: boolean;
  @Input() showIdentificationNumbers: boolean;
  @Input() showStorageLocation: boolean;

  public showOptions = false;
  public showDetails: boolean;
  public InfoBoxType = InfoBoxType;

  public get showError(): boolean {
    if (!this.showIdentificationNumbers) {
      return false;
    }
    if (!this.articleLine.quantity) {
      return false;
    }
    if (
      this.articleLine.article.requiresSerialnumber &&
      (!this.articleLine.serialNumber || !this.articleLine.operatingHours)
    ) {
      return true;
    }
    if (this.articleLine.article.requiresBatchnumber && !this.articleLine.batchNumber) {
      return true;
    }
    if (!this.articleLine.resmedTenant) {
      return true;
    }
    return false;
  }

  ngOnInit(): void {
    if (!this.articleLine.storageLocation && this.user && this.node.options?.showStorageLocation) {
      this.articleLine.storageLocation = this.user.storageLocation;
    }
    if (!this.articleLine.resmedTenant && this.patient) {
      this.articleLine.resmedTenant = this.patient.resmedTenant;
    }
  }
}
